import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { SharedService } from '../shared.service';
import { Subscription } from 'rxjs';
import { Labels } from '../model/language.model.class';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.css']
})
export class BottomBarComponent implements OnInit, OnDestroy {

  @Input() labels: Labels;

  @Input() showRefresh = true;
  @Input() showLegenda = true;
  @Input() showView = true;
  @Input() showSplitView = true;
  @Input() showSidebar = true;

  @Output() refresh = new EventEmitter<void>();
  @Output() onLegendaButtonClicked = new EventEmitter<void>();
  @Output() onSidebarButtonClicked = new EventEmitter<boolean>();
  @Output() onVisitFilterButtonClicked = new EventEmitter<void>();
  @Output() onSplitViewButtonClicked = new EventEmitter<boolean>();

  buttons: { [key: string]: { id: string; label: string } } = {};
  buttonsObject: { id: string; label: string }[] = [];

  buttonsVisible = true;
  textVisible = true;
  iconPath = 'assets/hide-bottom-bar.svg';
  splitViewVisible: boolean = false;

  viewText: string = '';
  private subscription: Subscription;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.subscription = this.sharedService.viewText$.subscribe(optionSelected => {
      this.setViewButtonLabel();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
   
    if (changes['labels'] && this.labels) {
      this.buttonsObject = [
        { id: "Refresh", label: this.labels.CentralToolBar['Refresh'] },
        { id: "Legenda", label: this.labels.CentralToolBar['Legenda'] },
        { id: "View", label: this.labels.CentralToolBar['View'] },
        { id: "SplitView", label: this.labels.CentralToolBar['SplitView'] },
        { id: "Sidebar", label: this.labels.CentralToolBar['Sidebar'] },
        { id: "Hide", label: this.labels.CentralToolBar['Hide'] },
      ];
      this.buttons = {};
      for (const b of this.buttonsObject) {
        this.buttons[b.id] = b;
      }
      this.setViewButtonLabel();
    }
  }

  setViewButtonLabel() {
    const filters = this.sharedService.getVisitFilterOptions();
    const selectedCount = filters.filter(o => o.selected).length;
    if (selectedCount == filters.length) {
      this.viewText = `${this.labels.CentralToolBar['View']} (${this.labels.CentralToolBar['View_all']})`;
    } else {
      this.viewText = `${this.labels.CentralToolBar['View']} (${selectedCount})`;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleButtons() {
    this.buttonsVisible = !this.buttonsVisible;
    this.textVisible = !this.textVisible;
    this.iconPath = this.buttonsVisible ? 'assets/hide-bottom-bar.svg' : 'assets/show-bottom-bar.svg';
  }

  onRefreshClick() {
    this.sharedService.isVendorPopupVisible = false;
    this.refresh.emit();
  }

  onLegendaClick() {
    this.onLegendaButtonClicked.emit();
  }

  onVisitFilterClick()
  {
    this.onVisitFilterButtonClicked.emit();
  }

  onSplitViewClick() {
    this.sharedService.isVendorPopupVisible = false;
    this.onSplitViewButtonClicked.emit();
  }

  onSidebarClick() {
    this.sharedService.isVendorPopupVisible = false;
    this.sharedService.toggleBarsVisibility();
  }

}



// WEBPACK FOOTER //
// ./src/app/bottom-bar/bottom-bar.component.ts